import {Stack} from '@mui/material';
import {MainHeader, PageWrapperLayout, Snackbar} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {useAddFavoriteAddress} from './hooks/useAddFavoritePlace';
import {Address} from 'presentation/components/ChangeData/Address';
import {FavoriteAddressTutorials} from './components/FavoriteAddressTutorials';
import {FAVORITE_ADDRESS_TUTORIAL_STEPS} from './components/FavoriteAddressTutorials/constants';

const {newAddress, saveAddress, addFavoritePlace} =
	translations['pt-br'].privateFlow.bookingFlow.location;

export function FavoriteAddressesAdd() {
	const {
		isMobOrTab,
		initialReverseGeocodeData,
		handleBack,
		onSubmit,
		openAddFavoriteAddressSuccess,
		handleCloseFavoriteAddressSuccess,
		openAddFavoriteAddressError,
		handleCloseAddFavoriteAddressError,
		isPostingFavoriteAddress,
		hasCasaAddress,
		shouldForceCasaOnly,
		item,
	} = useAddFavoriteAddress();

	return (
		<PageWrapperLayout title={newAddress}>
			<MainHeader title={newAddress} handleBack={handleBack} hideProfileMenu />
			<Stack
				paddingX={isMobOrTab ? 2 : 5}
				paddingY={isMobOrTab ? 2 : 3}
				mb={isMobOrTab ? 10 : 0}
				gap={3}>
				<Address.FormV2
					onCancel={handleBack}
					onSave={onSubmit}
					initialReverseGeocodeData={initialReverseGeocodeData}
					address={item}
					withoutAlertInfo
					withoutCancelButton
					responsiveButtons
					hasFavoriteAddressField
					forceMainAddress={shouldForceCasaOnly}
					hasCasaAddress={hasCasaAddress}
					isEditingCasaAddress={false}
					saveLabel={saveAddress}
					loading={isPostingFavoriteAddress}
					enableCepNotFoundError
				/>
			</Stack>
			<Snackbar
				open={openAddFavoriteAddressError}
				message={addFavoritePlace.error}
				onClose={handleCloseAddFavoriteAddressError}
			/>
			<Snackbar
				open={openAddFavoriteAddressSuccess}
				message={addFavoritePlace.success}
				onClose={handleCloseFavoriteAddressSuccess}
				autoHideDuration={1500}
			/>
			<FavoriteAddressTutorials step={FAVORITE_ADDRESS_TUTORIAL_STEPS.ADD_SEARCH} />
			<FavoriteAddressTutorials step={FAVORITE_ADDRESS_TUTORIAL_STEPS.ADD_IDENTIFICATION} />
		</PageWrapperLayout>
	);
}
